<form class="specifications-form" [formGroup]="tradeInSpecificationsForm">
  <app-ice-input-field
    formControlName="imei"
    inputWidth="medium"
    label="IMEI-nummer"
    ngDefaultControl
    ngxsFormPath="formState.tradeInForm"
    textTestId="imei-input"
    [errorText]="!validateTradeInImeiError ? 'Ikke gyldig IMEI-nummer' : ''"
    [readonly]="isValidatingImei()"
  />
  <app-information-button
    [activeLabel]="'Skjul informasjon'"
    [inactiveLabel]="'Hvordan finner jeg IMEI-nummeret?'"
    (toggleInfo)="toggleActiveInformation(OSAffectedControlType.Imei)"
  />
  @if (!!validateTradeInImeiError) {
    <app-ice-alert class="error-alert" type="error">
      <div heading>MobilPant er ikke tilgjengelig</div>
      <div>{{ validateTradeInImeiError }}</div>
    </app-ice-alert>
  }

  @if (isValidatingImei()) {
    <app-spinner class="spinner" />
  } @else {
    <div class="storage">
      <label class="storage-label">Lagringskapasitet</label>
      <mat-form-field appearance="outline" class="ice-custom-mat-select">
        <mat-select ngDefaultControl [compareWith]="compareStorageCapacity" [formControl]="storageControl">
          @if (storageControl.disabled && storageCapacityAlternatives().length === 0) {
            <mat-option value="" [disabled]="true">IMEI mangler</mat-option>
          }
          @if (!storageControl.value) {
            <mat-option value="" [disabled]="true">Ingen valgt</mat-option>
          }
          @for (storage of storageCapacityAlternatives() | sortBy: 'size'; track storage.size + storage.unit) {
            <mat-option [value]="storage">{{ storage.size }}&nbsp;{{ storage.unit }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <app-information-button
        [activeLabel]="'Skjul informasjon'"
        [inactiveLabel]="'Hvordan finner jeg lagringskapasitet?'"
        (toggleInfo)="toggleActiveInformation(OSAffectedControlType.Storage)"
      />
    </div>
  }
</form>
